module.exports = __webpack_public_path__ + "img/pie-chart.439e38e4.svg";